import { render, staticRenderFns } from "./Repository.vue?vue&type=template&id=2fe859c6&scoped=true&"
import script from "./Repository.vue?vue&type=script&lang=js&"
export * from "./Repository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe859c6",
  null
  
)

export default component.exports